<template>
  <v-app>

  <link rel="stylesheet" href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
  integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
  crossorigin=""/>


  <v-app-bar v-if="showMenu" app>
    <v-menu offset-y 
            close-on-click 
            close-on-content-click 
            transition="slide-y-transition"
    >
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon
          color="black"
          dark
          v-on="on"
        >
        </v-app-bar-nav-icon>
      </template>
      <v-list height=auto>
        <v-list-item
          @click="item.action"
          v-for="(item, index) in menuElements"
          :key="index"
          style="margin : 10px;"
        >
          <v-icon>{{ item.icon }}</v-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <v-spacer></v-spacer>
    <v-btn @click="modal = true">
      <v-icon left>mdi-calendar</v-icon>
      {{ date }}
    </v-btn>
    
  </v-app-bar>

  <!-- Sizes your content based upon application components -->
  <v-content>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <v-date-picker 
          v-model="dateTemp" 
          scrollable 
          :events="arrayEvents"
          event-color="green lighten-1" 
          locale="es" 
          first-day-of-week=1
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cerrar</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(dateTemp)">Aceptar</v-btn>
        </v-date-picker>
    </v-dialog>
      <!-- If using vue-router -->
      <router-view @updateTitle="updateTitle" v-bind:date="date"></router-view>
    </v-container>
  </v-content>

  <v-bottom-navigation v-if="showMenu" app>
    <v-btn @click="$router.push('/orders')">
      <span>Pedidos</span>
      <v-icon>mdi-basket</v-icon>
    </v-btn>
    
    <v-btn @click="$router.push('/products')">
      <span>Productos</span>
      <v-icon>mdi-cube</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/routes')">
      <span>Rutas</span>
      <v-icon>mdi-map-marker</v-icon>
    </v-btn>
  </v-bottom-navigation>
</v-app>
</template>

<script>
/* eslint-disable  */

  import MenuToggleBtn from '@/components/MenuToggleBtn.vue'
  import Menu from '@/components/Menu.vue'
  import ContentOverlay from '@/components/ContentOverlay.vue'
  import Vue from 'vue';
  import VueCarousel from '@chenfengyuan/vue-carousel';
  import { Messaging } from './firebase/messaging';
  import { Auth } from './firebase/auth';
  import { DB } from './firebase/db';

  //var moment = require('moment');
  import moment from 'moment';
  moment.locale('es');  

  Vue.component(VueCarousel.name, VueCarousel);

  var request = require('request');

export default {
  name: 'App',

  components: {
    MenuToggleBtn,
    Menu,
    ContentOverlay
  },

  async created() {
    console.log("Created App");

    window.bus.$on('menu/toggle', () => {
    window.setTimeout(() => {
        this.isOpenMobileMenu = !this.isOpenMobileMenu;
      }, 200);
    });

    window.bus.$on('menu/closeMobileMenu', () => {
      this.isOpenMobileMenu = false;
    });

    window.bus.$on('menu/desactivarMenu', () => {
      this.menuActivado = false;
    });

    window.bus.$on('menu/activarMenu', () => {
      this.menuActivado = true;
    });


    let user = await Auth.getCurrentUser();

    if(user != null){
      Messaging.requestPermission()
      .then(() => {
        console.log("Have permission");
        return Messaging.getToken();
      })
      .then( token => {
        console.log(token);
        if(token) {
          this.sendTokenToServer(token);
        }
        else {
          console.log('No Instance ID token available.');
          this.setTokenSentToServer(false);
        }
      })
      .catch( err => {
        console.log('An error occurred while retrieving token. ', err);
        this.setTokenSentToServer(false);
      })

      Messaging.onTokenRefresh(() => {
        Messaging.getToken().then((refreshedToken) => {
          console.log('Token refreshed.');
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
        }).catch((err) => {
          console.log('Unable to retrieve refreshed token ', err);
        });
      });

      Messaging.onMessage( payload => {
        console.log("onMessage: ", payload);
      })
    }
  },

  data() {
    return {
      dateTemp: moment().format("YYYY-MM-DD"),
      date: moment().format("YYYY-MM-DD"),
      modal: false,
      orders: [],
      arrayEvents: [],
      selectedElement : {},
      selectedElementIndex: -1,
      menuElements: [
        { icon: 'mdi-account',title : 'Perfil', action : this.openProfile},
        { icon: 'mdi-logout', title : 'Cerrar sesion', action : this.logout},
      ], 
      title: '',
      styleActivado: {
        display: 'block'
      },
      styleDesactivado: {
        display: 'none'
      },
    };
  },

  mounted () {
    Auth.onAuthStateChanged( user => {
      if(user != null){
        this.getOrders();
      }
    });
  },

  methods : {
    getOrders() {
        this.orders.splice(0);
        this.arrayEvents.splice(0);

        DB.collection('orders')
        .onSnapshot( snapshots => {

          snapshots.docs.forEach( item => {
              
            let element = {
              formattedDate : moment(item.data().date).format("DD-MM-YYYY"),
              date : item.data().date,
              isDelivered : item.data().isDelivered,
              user : item.data().user,
              products : item.data().products,
              id : item.id,
              location: item.data().location,
              avatar: item.data().userPhoto,
              address: item.data().address
            }

            let index = -1;
            for (let i = 0; i < this.orders.length; i++) {
              if(this.orders[i].id == item.id)
              {
                index = i;
                break;
              }
            }

            if(index == -1){
              this.orders.push(element);
              this.arrayEvents.push(element.date);
            }
            else{
              this.orders[index].isDelivered = element.isDelivered;
            }
          })

          this.orders.sort((a, b) => {
            return moment(b.date).valueOf() - moment(a.date).valueOf();
          });
            
          this.loading = false;
        })
    },

    sendTokenToServer(currentToken) {
      if (!this.isTokenSentToServer()) {
        console.log("Sending token to server...");

        request.post('https://us-central1-supermercado-del-pueblo.cloudfunctions.net/subscribeClientToken', {
          json: {
            token : currentToken
          }
        },(error, res, body) => {
          if (error) {
            console.error(error)
            return
          }
          console.log(`Status: ${res.statusCode}\nBody: ${body}`)
        })

        this.setTokenSentToServer(true);
      }
      else {
        console.log('Token already sent to server so won\'t send it again unless it changes');
      }
    },

    isTokenSentToServer() {
      return window.localStorage.getItem('sentToServer') === '1';
    },

    setTokenSentToServer(sent) {
      window.localStorage.setItem('sentToServer', sent ? '1' : '0');
    },

    updateTitle(title) {
      this.title = title;
    },

    logout(){
      Auth.signOut()
      .then(() => {
        this.$router.go(Number.MIN_VALUE);
      })
      .catch( error => {
        alert(error);
      })
    },

    openProfile(){
      this.$router.push('/profile');
    }
  },

  computed: {
    showMenu() {
      return (this.$route.name !== 'login' && this.$route.name !== 'profile');
    },
    wrapperClass() {
      return {
        'toggled': this.isOpenMobileMenu === true,
      };
    },
  }
};
</script>

<style lang="scss">
  .mostrarMenu {
    display: none;
  }

  @media only screen and (orientation: landscape) and (max-width: 768px) {
    .logo {
      display: none !important;
    }
  }

  :root {
    --color-dark: #172b4d;
    --color-medium-dark: #0067a3;
    --color-medium: #0079bf;
    --color-medium-light: #3d99ce;
    --color-light: #00c2e0;
    --color-secondary-dark: #9D6600;
    --color-secondary-medium-dark: #DD8F00;
    --color-secondary-medium: #FFA500;
    --color-secondary-medium-light: #FFB01D;
    --color-secondary-light: #f3a953;
    --color-secondary-aux-dark: #FCE181;
    --color-secondary-aux-light: #FEF9C7;
    --color-grey: #EDEAE5;
    --color-white: #fff;
    --color-success: #2D8F1A;
    --color-danger-dark: #6A0500;
    --color-danger: #B80A01;
    --color-danger-medium: #E4190E;
    --color-danger-light: #F24B42;

    --color-menu-background: var(--color-medium);
    --color-menu-link-active: var(--color-medium-dark);
    --color-menu-hover: var(--color-dark);

    --color-logout-text: var(--color-secondary-light);
    --color-logout-hover: var(--color-secondary-light);
    --color-logout-background-hover: var(--color-dark);

    --color-toolbar: var(--color-medium);
    --color-toolbar-letra: var(--color-white);
    --color-toolbar-button: var(--color-secondary-light);
    --color-toolbar-button-letra: var(--color-dark);

    --color-calendar: var(--color-toolbar);

    --color-map-path: var(--color-secondary-dark);

    --color-smile: var(--color-success);
    --color-frown: var(--color-danger);

    --marker-order-delivered: #2D8F1A;
    --marker-order-non-delivered: #d89c2f;
  }

  @import 'styles/layout.scss';
  @import 'styles/menu-toggle-btn.scss';
  @import 'styles/menu.scss';
  @import 'styles/content-overlay.scss';
  @import 'styles/media-queries.scss';

  .toolbars {
    background-color: var(--color-toolbar)!important;
    color: var(--color-toolbar-letra)!important;
  }

  .toolbar-button {
    background-color: var(--color-toolbar-button)!important;
    color: var(--color-toolbar-button-letra)!important;
  }

  #v-data-table {
    color: var(--color-secondary-light)!important;
  }

  .iconoTabla {
    width: 300px!important;
  }

  .colorPos {
    color: var(--color-smile)!important;
  }

  .colorNeg {
    color: var(--color-frown)!important;
  }

  .v-list{
    margin-top: -10px;
    margin-left: -10px;
    margin-right: -10px;
    height: 86vh;
    overflow-y:auto
  }

  #menuToggle {
    color: var(--color-medium);
  }

  #routeMap { 
    margin: -10px;
    margin-top: -215px;
    width: 99vw;
    height: 100vh;
    z-index: 0;
  }

  #mapInfo {
    z-index: 1;
  }
</style>